import useTranslation from 'next-translate/useTranslation';

import { Title } from '~/domains/design-system/Title';

interface SelectModalTitleProps {
  label?: string;
  showCustomOptions: boolean;
}

export function SelectModalTitle({ label, showCustomOptions }: SelectModalTitleProps) {
  const { t } = useTranslation('contest');
  if (showCustomOptions) {
    return (
      <Title ta="center" variant="headline-large">
        {t('manage.common.fields.selectModalFieldWithCustom.setCustomPickDeadline')}
      </Title>
    );
  }

  return (
    <Title ta="center" variant="headline-large">
      {label}
    </Title>
  );
}
